/** Bloc de code d'une carte (design system, BlocDeCode) : coloration, langage, « Copier ». */
import { useEffect, useState } from 'react';
import { Icone } from '../composants/Icone';
import { cx } from '../outils';
import { colorer, libelleLangage, type LigneColoree } from './coloration';

export function BlocDeCode({
  code,
  langage,
  numeros = false,
}: {
  code: string;
  langage?: string;
  numeros?: boolean;
}) {
  const [lignes, setLignes] = useState<LigneColoree[] | null>(null);
  const [copie, setCopie] = useState(false);
  const libelle = libelleLangage(langage);

  useEffect(() => {
    let actif = true;
    setLignes(null);
    void colorer(code, langage).then((resultat) => actif && setLignes(resultat));
    return () => {
      actif = false;
    };
  }, [code, langage]);

  useEffect(() => {
    if (!copie) return;
    const minuteur = window.setTimeout(() => setCopie(false), 2000);
    return () => window.clearTimeout(minuteur);
  }, [copie]);

  const brutes: LigneColoree[] = code
    .split('\n')
    .map((texte) => (texte ? [{ texte, classe: null }] : []));
  const affichees = lignes ?? brutes;

  return (
    <div className={cx('fc-bloc-code', numeros && 'fc-bloc-code--numeros')}>
      <pre
        className="fc-bloc-code__pre"
        tabIndex={0}
        role="group"
        aria-label={libelle ? `Code ${libelle}` : 'Code'}
      >
        {libelle && (
          <span className="fc-bloc-code__langage" aria-hidden="true">
            {libelle}
          </span>
        )}
        <code>
          {affichees.map((ligne, i) => (
            <span key={i} className="fc-bloc-code__ligne">
              {ligne.map((morceau, j) =>
                morceau.classe ? (
                  <span key={j} className={`fc-bloc-code__${morceau.classe}`}>
                    {morceau.texte}
                  </span>
                ) : (
                  morceau.texte
                ),
              )}
            </span>
          ))}
        </code>
      </pre>
      <button
        type="button"
        className="fc-bouton fc-bouton--secondaire fc-bouton--petit fc-bloc-code__copier"
        data-copie={copie ? 'true' : undefined}
        onClick={() => {
          void navigator.clipboard?.writeText(code).then(() => setCopie(true));
        }}
      >
        <Icone nom={copie ? 'check' : 'copy'} taille="petite" />
        <span className="fc-bloc-code__action">{copie ? 'Copié' : 'Copier'}</span>
      </button>
      <span className="fc-sr" role="status">
        {copie ? 'Code copié' : ''}
      </span>
    </div>
  );
}
